import { Servicio } from './Servicio';
export class ServicioFilter {
   servicioId: string;
   activo: boolean;
   exento: boolean;
   nombre: string;
   emisorId: string;
   sucursalId: string;
}
